import type { QualificationDemographic } from "../types";

import { Box, Text, Heading, ProgressBar } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

import React from "react";

export interface IDemographicChartProps {
  item: QualificationDemographic;
}

// Workaround for wrong margin setting in IFL implementation.
// We can remove it after JSMA-3163
const styles = {
  heading: {
    marginBottom: 8,
  },
};

const DemographicChart: React.FunctionComponent<IDemographicChartProps> = (
  props: IDemographicChartProps,
) => {
  const { item } = props;
  const gt = useI18n();

  return (
    <Box sx={{ marginBlockEnd: 16 }}>
      <Heading level={3} sx={styles.heading}>
        {item.title}
      </Heading>
      <Box sx={{ marginBlockEnd: 8 }}>
        <ProgressBar value={item.percent} showDataText={false} />
      </Box>
      <Text level={2}>{gt.gettext("{0}% of applicants have this", item.percent.toString())}</Text>
    </Box>
  );
};

export default DemographicChart;
